// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1mXoP","title":"BackImages_title__1CYpQ","images":"BackImages_images__ROYx0"};